// Source: https://shopify.dev/docs/api/ajax/section-rendering
const ROOT_SELECTOR = "[data-popular-products]";
const CONTENT_SELECTOR = ".p-featured-collection";

function getBestSellingProductsUrl(collectionUrl: string, sectionId: string) {
  const url = new URL(collectionUrl, window.location.origin);

  url.search = "";
  url.searchParams.set("sort_by", "best-selling");
  url.searchParams.set("section_id", sectionId);

  return url.pathname + url.search;
}

async function loadBestSellingProducts(root: Element) {
  const sectionId = root.getAttribute("data-section-id");
  const collectionUrl = root.getAttribute("data-collection-url");

  if (!sectionId || !collectionUrl) return;

  try {
    const response = await fetch(
      getBestSellingProductsUrl(collectionUrl, sectionId),
    );

    if (!response.ok) return;

    const doc = new DOMParser().parseFromString(
      await response.text(),
      "text/html",
    );
    const isCollectionElement = doc.querySelector(
      `${ROOT_SELECTOR} ${CONTENT_SELECTOR}`,
    );

    if (isCollectionElement) root.replaceChildren(isCollectionElement);
  } catch {
    return;
  }
}

export function initBestSellingProducts() {
  document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
    void loadBestSellingProducts(root);
  });
}
